export enum CertPolicies {
  CanViewLab = 'canViewLab',
  CanUpdateLab = 'canUpdateLab',
  CanMapRolePermissions = 'canMapRolePermissions',
  CanViewRolePermissions = 'canViewRolePermissions',
  CanViewDataDictionary = 'canViewDataDictionary',
  CanViewPersons = 'canViewPersons',
  CanCreatePersons = 'canCreatePersons',
  CanUpdatePersons = 'canUpdatePersons',
  CanDeletePersons = 'canDeletePersons',
  CanReviewDocuments = 'canReviewDocuments',
  CanModifySSNPersons = 'canModifySSNPersons',
  CanMergePersons = 'canMergePersons',
  CanViewPassedTests = 'canViewPassedTests',
  CanViewTests = 'canViewTests',
  CanCreateManualTests = 'canCreateManualTests',
  CanUpdateManualTests = 'canUpdateManualTests',
  CanDeleteManualTests = 'canDeleteManualTests',
  CanModifyTestFeedTests = 'canModifyTestFeedTests',
  CanViewEducation = 'canViewEducation',
  CanCreateEducation = 'canCreateEducation',
  CanUpdateEducation = 'canUpdateEducation',
  CanDeleteEducation = 'canDeleteEducation',
  CanReceiveApplications = 'canReceiveApplications',
  CanViewApplications = 'canViewApplications',
  CanUpdateApplications = 'canUpdateApplications',
  CanDeleteApplications = 'canDeleteApplications',
  CanManageAdminQueue = 'canManageAdminQueue',
  CanAssignServiceItemToOthers = 'canAssignServiceItemToOthers',
  CanViewManualFingerprintCards = 'canViewManualFingerprintCards',
  CanCreateManualFingerprintCards = 'canCreateManualFingerprintCards',
  CanDeleteManualFingerprintCards = 'canDeleteManualFingerprintCards ',
  CanViewDPSFingerprintCards = 'canViewDPSFingerprintCards',
  CanDeleteDPSFingerprintCards = 'canDeleteDPSFingerprintCards',
  CanManageDpsFingerprintMismatches = 'canManageDpsFingerprintMismatches',
  CanViewCER = 'canViewCER',
  CanCreateCER = 'canCreateCER',
  CanUpdateCER = 'canUpdateCER',
  CanDeleteCER = 'canDeleteCER',
  CanViewNotes = 'canViewNotes',
  CanCreateNotes = 'canCreateNotes',
  CanUpdateNotes = 'canUpdateNotes',
  CanDeleteNotes = 'canDeleteNotes',
  CanSelfAssignServiceItems = 'canSelfAssignServiceItems',
  CanUpdateBackgroundCheckAfterPayment = 'canUpdateBackgroundCheckAfterPayment',
  CanViewCertificates = 'canViewCertificates',
  CanDeleteCertificates = 'canDeleteCertificates',
  CanUpdateCertificateStatuses = 'canUpdateCertificateStatuses',
  CanUpdateCertificates = 'canUpdateCertificates',
  CanUpdateCertificateDates = 'canUpdateCertificateDates',
  CanUpdateCertificateLeaAndPpi = 'canUpdateCertificateLeaAndPpi',
  CanViewPayments = 'canViewPayments',
  CanEnterPaymentReversal = 'canEnterPaymentReversal',
  CanEnterPaymentRedeposit = 'canEnterPaymentRedeposit',
  CanAddEvaluations = 'canAddEvaluations',
  CanEditEvaluations = 'canEditEvaluations',
  CanConfigureDenials = 'canConfigureDenials',
  CanAddCustomIncompleteReasons = 'canAddCustomIncompleteReasons',
  CanApproveCancellations = 'canApproveCancellations',
  CanUploadDocuments = 'canUploadDocuments',
  CanInitiateHold = 'canInitiateHold',
  CanViewCollectedPaymentsReport = 'canViewCollectedPaymentsReport',
  CanViewPaymentReversalReport = 'canViewPaymentReversalReport',
  CanSendPaymentReversalToCollections = 'canSendPaymentReversalToCollections',
  CanProcessRefunds = 'canProcessRefunds',
  CanCreatePrintJobs = 'canCreatePrintJobs',
  CanViewNasdtecEntries = 'canViewNasdtecEntries',
  CanUpdateNasdtecEntries = 'canUpdateNasdtecEntries',
  CanViewInvestigativeAlerts = 'canViewInvestigativeAlerts',
  CanViewCaseIQ = 'canViewCaseIQ',
  CanManuallyProcessCaseIQCaseClosures = 'canManuallyProcessCaseIQCaseClosures',
  CanViewDiscipline = 'canViewDiscipline',
  CanAddDiscipline = 'canAddDiscipline',
  CanUpdateDiscipline = 'canUpdateDiscipline',
  CanDeleteDiscipline = 'canDeleteDiscipline',
  CanViewDisciplineNotes = 'canViewDisciplineNotes',
  CanManuallyCompleteInvestigativeReview = 'canManuallyCompleteInvestigativeReview',
  CanPerformFinalSIReview = 'canPerformFinalSIReview',
  CanProcessAppeals = 'canProcessAppeals',
  CanViewCohort = 'canViewCohort',
  CanAddCohort = 'canAddCohort',
  CanUpdateCohort = 'canUpdateCohort',
  CanDeleteCohort = 'canDeleteCohort',
  CanAddStudentsToCohort = 'canAddStudentsToCohort',
  CanTransferStudentsToCohort = 'canTransferStudentsToCohort',
  CanRemoveStudentFromCohort = 'canRemoveStudentFromCohort',
  CanAuthorizeRecommendation = 'canAuthorizeRecommendation',
  CanDeleteRecommendation = 'canDeleteRecommendation',
  CanSubmitUnprofessionalConductReport = 'canSubmitUnprofessionalConductReport',
  CanSearchEducators = 'canSearchEducators',
  CanManageHelpObjects = 'canManageHelpObjects',
  CanManagePageAlerts = 'canManagePageAlerts',
  CanManageHangfire = 'canManageHangfire',
  CanAddAlerts = 'canAddAlerts',
  CanDeleteAlerts = 'canDeleteAlerts',
  CanPrintVerificationLetter = 'canPrintVerificationLetter',
  CanViewPersonDemographics = 'canViewPersonDemographics',
  CanViewPersonFullSsn = 'canViewPersonFullSsn',
  CanViewPersonContact = 'canViewPersonContact',
  CanGenerateCertificates = 'canGenerateCertificates',
  CanApprovePendingPayments = 'canApprovePendingPayments',
  CanCloseServiceItems = 'canCloseServiceItems',
  CanLinkEducators = 'canLinkEducators',
  CanMergeEducators = 'canMergeEducators',
  CanViewLeaContacts = 'canViewLeaContacts',
  CanEditLeaContacts = 'canEditLeaContacts',
  CanDeleteLeaContacts = 'canDeleteLeaContacts',
  CanViewLeaSiteContacts = 'canViewLeaSiteContacts',
  CanEditLeaSiteContacts = 'canEditLeaSiteContacts',
  CanDeleteLeaSiteContacts = 'canDeleteLeaSiteContacts',
  CanUseLeaContactTestingTools = 'canUseLeaContactTestingTools',
  CanInvalidateLeaContacts = 'canInvalidateLeaContacts',
  CanViewLeaContactsInCert = 'canViewLeaContactsInCert',
  CanManageLeaStaffRoster = 'canManageLeaStaffRoster',
  CanManuallyRecalculateAC = 'canManuallyRecalculateAC',
  CanViewAdminConfigurations = 'canViewAdminConfigurations',
  CanManageCredentialConfigurations = 'canManageCredentialConfigurations',
  CanManageLeaConfigurations = 'canManageLeaConfigurations',
  CanManageEppConfigurations = 'canManageEppConfigurations',
  DeleteBackgroundIssuesAgencyRestricted = 'deleteBackgroundIssuesAgencyRestricted',
  DeleteBackgroundIssuesDrivingRestricted = 'deleteBackgroundIssuesDrivingRestricted',
  CanAddBackgroundIssuesSBENoAction = 'canAddBackgroundIssuesSBENoAction',
  CanDeleteBackgroundIssuesSBENoAction = 'canDeleteBackgroundIssuesSBENoAction',
  CanUpdateTitleIStatus = 'canUpdateTitleIStatus',
  CanManageLeaStaffPositions = 'canManageLeaStaffPositions',
  CanViewLea = 'canViewLea',
  CanManageLeaUploads = 'canManageLeaUploads',
  CanViewEvalTool = 'canViewEvalTool',
  CanManageEvaluations = 'canManageEvaluations',
  CanManageSurveys = 'canManageSurveys',
  CanManageLeaYearTransition = 'canManageLeaYearTransition',
  CanLockLeaSystem = 'canLockLeaSystem',
  CanViewLeaSurveys = 'canViewLeaSurveys',
  CanViewPerformanceEvaluations = 'canViewPerformanceEvaluations',
  CanEditPerformanceEvaluations = 'canEditPerformanceEvaluations',
  CanAddRushToServiceItems = 'canAddRushToServiceItems',
  CanRemoveRushFromServiceItems = 'canRemoveRushFromServiceItems',
  CanManageReports = 'canManageReports',
  CanManageVoucherPrograms = 'canManageVoucherPrograms',
  CanManageRetroactiveVouchers = 'canManageRetroactiveVouchers',
  CanViewAdminReports = 'canViewAdminReports',
  CanViewVoucherReports = 'canViewVoucherReports',
  CanManageLeaVoucherCredits = 'canManageLeaVoucherCredits',
  CanManageEppVoucherCredits = 'canManageEppVoucherCredits',
  CanAssignProfessionalDevelopmentRequests = 'canAssignProfessionalDevelopmentRequests',
  CanVerifyProfessionalDevelopment = 'canVerifyProfessionalDevelopment',
  CanVerifyCertProfessionalDevelopment = 'canVerifyCertProfessionalDevelopment',
  CanResetPersonInformation = 'canResetPersonInformation',
  CanInitiateEducatorScreenShare = 'canInitiateEducatorScreenShare',
  CanLeaCreatePersons = 'canLeaCreatePersons',
  CanViewLeaWorkforceInformation = 'canViewLeaWorkforceInformation',
  CanViewLeaCredentialManagementRoster = 'canViewLeaCredentialManagementRoster',
  CanCompleteLeaSurveys = 'canCompleteLeaSurveys',
  CanRedeemRetroactiveVoucherCreditsDuringEvaluation = 'canRedeemRetroactiveVoucherCreditsDuringEvaluation',
  CanEditEndedAssignmentsAndEmployments = 'canEditEndedAssignmentsAndEmployments',
}
